<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar cad color="primary" dark dense flat>
            <v-toolbar-title class="subheading">
              {{ $route.meta.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3"
                    >DETALLES DEL LABORATORIO</v-subheader
                  >
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('firstName')"
                    data-vv-name="name"
                    label="Nombre"
                    required
                    v-model="form.name"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('phone')"
                    data-vv-name="phone"
                    label="Teléfono"
                    required
                    v-model="form.phone"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    chips
                    label="Emails para Notificaciones"
                    multiple
                    no-data-text="Datos no disponibles"
                    v-model="form.emails"
                  ></v-combobox>
                </v-flex>
                <v-flex md12 xs12>
                  <v-textarea
                    data-vv-name="address"
                    label="Dirección"
                    v-model="form.address"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3"
                    >PERSONA DE CONTACTO</v-subheader
                  >
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('firstName')"
                    data-vv-name="firstName"
                    label="Nombre"
                    required
                    v-model="form.contact.firstName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('lastName')"
                    data-vv-name="lastName"
                    label="Apellido"
                    required
                    v-model="form.contact.lastName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                    label="Email"
                    required
                    type="email"
                    v-model="form.contact.email"
                    v-validate="'required|email'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :error-messages="errors.collect('password')"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    data-vv-name="password"
                    label="Contraseña"
                    required
                    v-if="!form.id"
                    v-model="form.contact.password"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3">CONTABLE</v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="accountings"
                    label="Contable"
                    no-data-text="Datos no disponibles"
                    v-model="form.accId"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-btn @click="submit" color="success">Enviar</v-btn>
                  <v-btn @click="cancel" color="error">Cancelar</v-btn>
                </v-flex>

                <v-dialog
                  max-width="500"
                  v-if="dialog.message"
                  v-model="dialog.show"
                >
                  <message
                    :key="dialog.key"
                    :options="dialog"
                    v-on:close="dialog.show = false"
                  ></message>
                </v-dialog>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import message from './../dialog/Message'
export default {
  components: {
    message,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          name: '',
          phone: '',
          address: '',
          emails: [],
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
          },
          accId: '',
        }
      },
    },
  },
  data() {
    return {
      showPassword: false,
      accountings: [],
      dialog: {
        show: false,
        key: 0,
      },
    }
  },
  created() {
    this.$store.dispatch('users/getAll', { roleId: 3 }).then(response => {
      const userAccount = response.items
      for (let index = 0; index < userAccount.length; index += 1) {
        this.accountings.push({
          text: `${userAccount[index].firstName} ${
            userAccount[index].lastName
          }`,
          value: userAccount[index].id,
        })
      }
    })

    if ('id' in this.$route.params) {
      this.$store
        .dispatch('laboratories/getById', {
          id: this.$route.params.id,
        })
        .then(response => {
          if (response) {
            const emails = response.emails ? response.emails.split(',') : []

            this.form = Object.assign(this.form, {
              id: response.id,
              name: response.name,
              phone: response.phone,
              address: response.address,
              emails: emails,
              contact: {
                firstName: response.contact.firstName,
                lastName: response.contact.lastName,
                email: response.contact.email,
              },
              accId: response.accounting !== null ? response.accounting.id : '',
            })
          } else {
            this.$router.push('/laboratorios/listado')
          }
        })
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch('laboratories/save', this.form)
            .then(response => {
              if (response.status === 200) {
                if (this.form.id) {
                  this.dialog = {
                    message: 'Los datos fueron actualizados exitosamente',
                    color: 'primary',
                    show: true,
                    key: this.dialog.key + 1,
                  }
                } else {
                  this.$router.push('/laboratorios/listado')
                }
              } else {
                this.dialog = {
                  message: response.data.error,
                  color: 'error',
                  show: true,
                  key: this.dialog.key + 1,
                }
              }
            })
        }
      })
    },
    reset() {
      this.$validator.reset()
    },
    cancel() {
      this.$router.push('/laboratorios/listado')
    },
  },
}
</script>
